<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <div class="section white-panel pt24 pb8 mb16">
          <p class="text-center mb16"><img src="/lib/images/ic_done_1.svg" alt=""></p>
          <div>
            <p class="fs20 font-weight-bold text-center line-height1_7 mt20 mb20">お申し込みが完了致しました。<br>
            お申込みいただいた店舗で入会金のお支払をお願い致します。</p>
          </div>
        </div>

        <div class="section transparent-panel">
          <router-link :to="{ name: 'MaintenancePackTopV2', query: {
              tsid: this.$route.query.tsid,
              popinfoid: this.$route.query.popinfoid,
              otoken: this.$route.query.otoken,
              ss_code: this.$route.query.ss_code,
              appVersion: this.$route.query.appVersion,
              platform: this.$route.query.platform,
              osVersion: this.$route.query.osVersion
            }}"
            style="text-decoration: none;"
            >
            <button class="button fs16 mt8 mb16 pd16 radius200 w80p"
            v-on:click="eventTrackMovedMPTop()">メンテナンスパック トップに戻る</button>
          </router-link>
        </div>
      </article>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
  },
  methods: {
    eventTrackMovedMPTop () {
      this.nativeEVENTSet('MpSubscriptionKanryouButton', 'MOVED_MP_TOP', 'TAP')
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    this.nativePVset('MpSubscriptionKanryou')
  }
}
</script>
